module.exports = __webpack_public_path__ + "e4b75c3864dd8122058b7a81c6be7447.png";